import React from "react"
import { TIMINGS, ANIMATION } from "../config/animation"
import "./block.scss"

// todo: add class to left align on mobile when children present

const TextBlock = ({
  icon,
  title,
  children,
  contrast,
  noUnderline,
  theme,
  contrast_color,
  underlineBellowText,
}) => {
  return (
    <section
      className={`block ${contrast ? "block--contrast" : ""} ${
        contrast_color ? "block--contrast_" + contrast_color : ""
      } `}
    >
      <div className={theme ? `centre ${theme}` : "centre"}>
        <div
          data-sal={ANIMATION.effect}
          data-sal-delay={TIMINGS.fast}
          data-sal-easing={ANIMATION.ease}
          data-sal-duration={ANIMATION.duration}
        >
          {icon && <img className="textblock__logo" src={icon} alt="" />}
          {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}

          {!noUnderline && <hr />}
          {children}
          {underlineBellowText && <hr />}
        </div>
      </div>
    </section>
  )
}

export default TextBlock
